"use client"

import { useEffect } from "react"

const PwaRegistrar = () => {
  useEffect(() => {
    // Production registers synchronously in <head>; development only clears stale workers.
    if (
      process.env.NODE_ENV === "production" ||
      typeof window === "undefined" ||
      !("serviceWorker" in navigator)
    ) {
      return
    }

    navigator.serviceWorker
      .getRegistrations()
      .then(registrations => {
        registrations.forEach(registration => {
          void registration.unregister()
        })
      })
      .catch(error => {
        console.error("Failed to clear service workers in development", error)
      })
  }, [])

  return null
}

export default PwaRegistrar
